import { render, staticRenderFns } from "./ReportSingleRmDetailsTable.vue?vue&type=template&id=89bcfff0&scoped=true&"
import script from "./ReportSingleRmDetailsTable.vue?vue&type=script&lang=js&"
export * from "./ReportSingleRmDetailsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89bcfff0",
  null
  
)

export default component.exports